export default "__VITE_ASSET__BxZAm9rp__"